module.exports = __webpack_public_path__ + "static/media/note.2115613b.svg";